module.exports = __webpack_public_path__ + "img/image_part_005.e0e014ea.jpg";